import styled from 'styled-components';

import {
  colorPrimary,
  colorBlack900,
  colorPrimaryLighten95,
  mediaQueryMobileMin,
  colorGrey200,
  colorPrimary200,
} from 'styles';

export const OptionList = styled.ul`
  display: flex;
  margin-left: auto;
  position: relative;

  @media all and ${mediaQueryMobileMin} {
    position: static;
  }
`;

export const Option = styled.li`
  color: ${colorBlack900};
  font-weight: 700;
  font-size: 14px;
  line-height: 31px;
  height: 32px;
  text-transform: uppercase;
  margin-right: 4px;
  padding: 0 8px;
  border: 1px solid ${colorGrey200};
  border-radius: 4px;
  cursor: pointer;

  ${({ name, current }) =>
    name === current &&
    `  
    background: ${colorPrimaryLighten95};
    border: 1px solid ${colorPrimary200};
    color: ${colorPrimary};
`}
  &:hover {
    background: ${colorPrimaryLighten95};
    border: 1px solid ${colorGrey200};
  }
`;
